import {Here} from '../../../service/Here'
import {UserDraw} from '../../../service/UserDraw'

const isDirtyLayer = ({ getters }, layerId) => {
  const layer = getters.getLayer(layerId)
  return layer.draft.dirty || false
}
const reverseGeocode = async ({ commit }, at, lang = "en-US", types= "address") => {
  const backEnd = Here.build({})
  try {
    const result = await backEnd.getReverseGeocode(at, lang, types)
    return result
  } catch (e) {
    throw e
  }
}
const saveFeatures = async ({ commit }, {projectId, requestId, features, render = "circle"}) => {
  const backEnd = UserDraw.build({})
  const payload = {
    'projectId': projectId,
    'requestId': requestId,
    'elements': {'type': 'FeatureCollection', 'features': features},
    'render': render
  }

  try {
    const res = await backEnd.save(payload)
    // console.log(JSON.stringify(res.data))
    return res.data.requestId
    // commit('toggleVisibility', layerId)
  } catch (e) {
   throw e
  }
}
const saveMarker = async ({ commit, dispatch }, payload) => {
  try {
    let { environmentId, projectId, requestId, layerName, features } = payload
    const createLayer = requestId === null
    const render = "symbol"
    const newRequestId = await dispatch('saveFeatures', { projectId, requestId, features, render })
    if (createLayer) requestId = newRequestId
    const layer = await dispatch('layer/createDrawLayer', { environmentId, projectId, requestId, layerName, render }, {root: true})
    if (createLayer) {
      const newLayer = await dispatch('layer/getLayerByUid', { environmentId, layerUid: newRequestId }, {root: true})
      const style = await dispatch('style/getCompositeStyle', newRequestId, {root: true})
      const result = {
        layer: newLayer,
        relation: {layer: newLayer, position: 0},
        style,
        legend: false,
        start: false,
        syncPos: true
      }
      return result
    } else {
      return true
    }
  } catch (e) {
    throw e
  }
}

export default {
  isDirtyLayer,
  reverseGeocode,
  saveFeatures,
  saveMarker
}
